import React from 'react';
import PropTypes from 'prop-types';
import Popover from 'material-ui/Popover';

import { isDesktop } from '../../utils/mobileHelpers';
import PopoverContent from './PopoverContent';

function InfoPopover({
  list,
  description,
  anchorEl,
  isOpen,
  onClose,
  anchorOrigin,
}) {
  return (
    <Popover
      open={isOpen}
      anchorEl={anchorEl}
      anchorOrigin={anchorOrigin}
      classes={{ paper: isDesktop() ? 'auto' : 'w-100' }}
    >
      <PopoverContent description={description} list={list} onClose={onClose} />
    </Popover>
  );
}

InfoPopover.propTypes = {
  list: PropTypes.array,
  anchorEl: PropTypes.object,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  description: PropTypes.string,
  anchorOrigin: PropTypes.object,
};

InfoPopover.defaultProps = {
  anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
};

export default InfoPopover;



// WEBPACK FOOTER //
// ./src/components/InfoPopover/index.jsx